// extracted by mini-css-extract-plugin
export default {"btn":"cookieConsentir_btn__6ebvA","p":"cookieConsentir_p__koc9z","Link":"cookieConsentir_Link__ysC2X"};